/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/
/* eslint-disable no-duplicate-imports */
import { Module } from '@msdyn365-commerce-modules/utilities';
import * as React from 'react';
import { ICitttaProductAttributeLinkViewProps } from './citta-product-attribute-link';

const ContentBlockView: React.FC<ICitttaProductAttributeLinkViewProps> = (props) => {
  const {
    contentBlockContainer,
    linkItem
  } = props;

  if (linkItem) {
    return (
      <Module {...contentBlockContainer}>
        { /* @ts-ignore */ }
        {linkItem}
      </Module>
    );
  } else {
    return (null);
  }
};

export default ContentBlockView;
